import { defineStore } from 'pinia'
import store from '@/store'
import { systemType } from '@/constants'
export const useConstantStore = defineStore("useConstantStore", () => {

    const headers = {
        'system-type': systemType,
        Authorization: 'Bearer ' + localStorage.getItem('token_blk')
    }
    const action = process.env.VUE_APP_BASE_URL + '/api/file/add_file'
    return { headers,action }
})
// 非setup
export function useConstantStoreHook() {
    return useConstantStore(store)
}